import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import TwilioDashboard from '../components/twilio/TwilioDashboard';
import TwilioSmsConsole from '../components/twilio/TwilioSmsConsole';
import TwilioCallsConsole from '../components/twilio/TwilioCallsConsole';
import TwilioNumbersView from '../components/twilio/TwilioNumbersView';
import TwilioLogsView from '../components/twilio/TwilioLogsView';
import TwilioSettings from '../components/twilio/TwilioSettings';
import TwilioIvrConsole from '../components/twilio/TwilioIvrConsole';
import IVRConsole from '../components/twilio/IVRConsole';
import VoiceAgentsView from '../components/twilio/VoiceAgentsView';

const TwilioControlPanel = () => {
  const location = useLocation();

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', path: '/twilio' },
    { id: 'sms', label: 'SMS', path: '/twilio/sms' },
    { id: 'calls', label: 'Calls', path: '/twilio/calls' },
    { id: 'numbers', label: 'Numbers', path: '/twilio/numbers' },
    // { id: 'ivr', label: 'IVR Builder', path: '/twilio/ivr-builder' },
    // Use new console
    { id: 'ivr-console', label: 'IVR Console', path: '/twilio/ivr' },
    { id: 'voice-agents', label: 'Voice Agents', path: '/twilio/voice-agents' },
    { id: 'logs', label: 'Webhooks / Logs', path: '/twilio/logs' },
    { id: 'settings', label: 'Settings', path: '/twilio/settings' },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Call Centre</h1>
        <p className="mt-2 text-gray-600">Manage your communications and services</p>
      </div>

      <div className="border-b border-gray-200 mb-8">
        <nav className="-mb-px flex space-x-8 overflow-x-auto">
          {tabs.map((tab) => (
            <Link
              key={tab.id}
              to={tab.path}
              className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
                location.pathname === tab.path
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </Link>
          ))}
        </nav>
      </div>

      <Routes>
        <Route path="/" element={<TwilioDashboard />} />
        <Route path="/sms" element={<TwilioSmsConsole />} />
        <Route path="/calls" element={<TwilioCallsConsole />} />
        <Route path="/numbers" element={<TwilioNumbersView />} />
        {/* <Route path="/ivr-builder" element={<IVRConsole />} /> */}
        <Route path="/ivr" element={<IVRConsole />} />
        <Route path="/voice-agents" element={<VoiceAgentsView />} />
        <Route path="/logs" element={<TwilioLogsView />} />
        <Route path="/settings" element={<TwilioSettings />} />
      </Routes>
    </div>
  );
};

export default TwilioControlPanel;